// @flow

export const UPDATE_BAND_DEVICE = 'band-redux/app/UPDATE_BAND_DEVICE';
export const CHANGE_SCREEN_CHANNEL = 'band-redux/app/CHANGE_SCREEN_CHANNEL';
export const CLEAR_SCREEN_CHANNEL = 'band-redux/app/CLEAR_SCREEN_CHANNEL';

